import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useTranslation } from '@crehana/i18n';
import Radio from "../../Radio";
import { Button } from "../Button";
import { DropdownValue } from "../Dropdown";
import { Input } from "../Input";
import { Popper, PopperContent, PopperTrigger } from "../Popper";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../Select";
import locales from "./i18n";
import { DefaultConditionalTypesEnum } from "./types";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var defaultOptions = [{
  label: 'DOES_NOT_CONTAIN',
  value: DefaultConditionalTypesEnum.NOT_CONTAINS,
  blockType: 'single'
}, {
  label: 'CONTAINS',
  value: DefaultConditionalTypesEnum.CONTAINS,
  blockType: 'single'
}, {
  label: 'RANGE',
  value: DefaultConditionalTypesEnum.RANGE,
  blockType: 'double'
}, {
  label: 'EQUALS',
  value: DefaultConditionalTypesEnum.EQUAL_TO,
  blockType: 'single',
  select: true
}, {
  label: 'ENDS_WITH',
  value: DefaultConditionalTypesEnum.ENDS_WITH,
  blockType: 'single'
}, {
  label: 'STARTS_WITH',
  value: DefaultConditionalTypesEnum.BEGINS_WITH,
  blockType: 'single'
}];
function RadioItemInput(_ref) {
  var blockType = _ref.blockType,
    onChange = _ref.onChange,
    defaultValue = _ref.defaultValue,
    type = _ref.type;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var _useState = useState((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[0]) || ''),
    _useState2 = _slicedToArray(_useState, 2),
    firstValue = _useState2[0],
    setFirstValue = _useState2[1];
  var _useState3 = useState((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[1]) || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    secondValue = _useState4[0],
    setSecondValue = _useState4[1];
  var handleInputChange = function handleInputChange(value, inputIndex) {
    if (inputIndex === 0) {
      setFirstValue(value);
      if (blockType === 'double') {
        onChange([value, secondValue]);
      } else {
        onChange([value]);
      }
    } else {
      setSecondValue(value);
      onChange([firstValue, value]);
    }
  };
  switch (blockType) {
    case 'single':
      return /*#__PURE__*/_jsx(Input, {
        className: "tw-w-full",
        autoComplete: "off",
        value: firstValue,
        onChange: function onChange(e) {
          return handleInputChange(e.target.value, 0);
        },
        type: type
      });
    case 'double':
      return /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-items-center tw-gap-1 tw-pt-0.8",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-max-w-[9rem]",
          children: /*#__PURE__*/_jsx(Input, {
            className: "tw-w-full",
            autoComplete: "off",
            value: firstValue,
            onChange: function onChange(e) {
              return handleInputChange(e.target.value, 0);
            },
            type: type
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "tw-font-body4",
          children: locales[languageCode].TO
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-max-w-[9rem]",
          children: /*#__PURE__*/_jsx(Input, {
            className: "tw-w-full",
            autoComplete: "off",
            value: secondValue,
            onChange: function onChange(e) {
              return handleInputChange(e.target.value, 1);
            },
            type: type
          })
        })]
      });
    default:
      return null;
  }
}
export function ConditionalSelect(_ref2) {
  var options = _ref2.options,
    placeholder = _ref2.placeholder,
    onSelect = _ref2.onSelect,
    disabled = _ref2.disabled,
    applyButtonLabel = _ref2.applyButtonLabel,
    noInputs = _ref2.noInputs,
    _ref2$showValueInDrop = _ref2.showValueInDropdown,
    showValueInDropdown = _ref2$showValueInDrop === void 0 ? false : _ref2$showValueInDrop,
    defaultValue = _ref2.defaultValue,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'text' : _ref2$type;
  var _useTranslation2 = useTranslation(),
    languageCode = _useTranslation2.languageCode;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var _useState7 = useState(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.option),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedOption = _useState8[0],
    setSelectedOption = _useState8[1];
  var _useState9 = useState((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.values) || []),
    _useState0 = _slicedToArray(_useState9, 2),
    inputValues = _useState0[0],
    setInputValues = _useState0[1];
  var renderOptions = options || defaultOptions.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      label: locales[languageCode][option.label]
    });
  });
  var getFormattedLabel = function getFormattedLabel() {
    var option = renderOptions.find(function (opt) {
      return opt.value === selectedOption;
    });
    if (option) {
      var displayValue = option.blockType === 'double' ? "".concat(option.label, ": ").concat(inputValues[0], " - ").concat(inputValues[1]) : "".concat(option.label, ": ").concat(inputValues[0]);
      return displayValue;
    }
    return undefined;
  };
  var _useState1 = useState(getFormattedLabel() || ''),
    _useState10 = _slicedToArray(_useState1, 2),
    forcedValue = _useState10[0],
    setForcedValue = _useState10[1];
  var handleOptionSelect = function handleOptionSelect(value) {
    setSelectedOption(value);
    setInputValues([]);
    if (noInputs) {
      onSelect === null || onSelect === void 0 ? void 0 : onSelect({
        option: value,
        values: []
      });
      setIsOpen(false);
    }
  };
  var handleInputChange = function handleInputChange(values) {
    setInputValues(values);
  };
  var handleApply = function handleApply() {
    if (selectedOption && onSelect) {
      onSelect({
        option: selectedOption,
        values: inputValues
      });
      if (showValueInDropdown) {
        var displayValue = getFormattedLabel();
        if (displayValue) {
          setForcedValue(displayValue);
        }
      }
    }
    setIsOpen(false);
  };
  if (noInputs) {
    var _defaultValue$option;
    return /*#__PURE__*/_jsxs(Select, {
      onValueChange: function onValueChange(value) {
        return handleOptionSelect(value);
      },
      disabled: disabled,
      defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : (_defaultValue$option = defaultValue.option) === null || _defaultValue$option === void 0 ? void 0 : _defaultValue$option.toString(),
      children: [/*#__PURE__*/_jsx(SelectTrigger, {
        className: "tw-w-full",
        children: /*#__PURE__*/_jsx(SelectValue, {
          placeholder: placeholder
        })
      }), /*#__PURE__*/_jsx(SelectContent, {
        className: "tw-w-full",
        children: renderOptions.filter(function (option) {
          return option.blockType === 'single';
        }).map(function (option) {
          return /*#__PURE__*/_jsx(SelectItem, {
            value: option.value.toString(),
            children: option.label
          }, option.value);
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Popper, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: [/*#__PURE__*/_jsx(PopperTrigger, {
      asChild: true,
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(DropdownValue, {
          className: "tw-flex tw-w-full tw-pointer-events-none",
          size: "small",
          placeholder: placeholder,
          disabled: disabled,
          forcedValue: showValueInDropdown ? forcedValue : undefined
        })
      })
    }), /*#__PURE__*/_jsxs(PopperContent, {
      className: "tw-w-full tw-m-0",
      removePadding: true,
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-flex-col tw-items-start tw-gap-1 tw-rounded tw-px-2.4 tw-py-1.6 tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-03 tw-w-full",
        children: renderOptions.map(function (option) {
          return /*#__PURE__*/_jsxs("div", {
            className: "tw-w-full",
            children: [/*#__PURE__*/_jsx(Radio, {
              inputElProps: {
                name: 'conditional-select'
              },
              className: "tw-py-0.2",
              size: "s",
              checked: selectedOption === option.value,
              onChange: function onChange() {
                return handleOptionSelect(option.value);
              },
              title: option.label
            }), selectedOption === option.value && /*#__PURE__*/_jsx(RadioItemInput, {
              blockType: option.blockType,
              onChange: handleInputChange,
              defaultValue: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.option) === option.value ? defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.values : undefined,
              type: type
            })]
          }, option.value);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-sticky tw-bg-neutral-light-200 tw-b-0 tw-w-full tw-px-2.4 tw-py-1.6 tw-flex tw-justify-start tw-items-center dark:tw-bg-elevation-dark-02",
        children: /*#__PURE__*/_jsx(Button, {
          type: "submit",
          variant: "primary",
          size: "xs",
          onClick: handleApply,
          children: applyButtonLabel || locales[languageCode].APPLY
        })
      })]
    })]
  });
}